import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { Category } from '@/models/category.model';

class CategoriesService extends BaseService {
  private url: string = '/api/category';

  constructor() {
    super();
  }

  public async get(id: number): Promise<DataResponse<Category>> {
    const res = await this.$http.get<Category>(`${this.url}/${id}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async getList(): Promise<DataResponse<Category[]>> {
    const res = await this.$http.get<Category[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async create(
    category: Partial<Category>,
  ): Promise<DataResponse<Category>> {
    const res = await this.$http.post<Category>(this.url, category);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async edit(category: Category): Promise<DataResponse<Category>> {
    const res = await this.$http.put<Category>(
      `${this.url}/${category.id}`,
      category,
    );

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async editSorting(
    category: Partial<Category>,
  ): Promise<DataResponse<Category>> {
    const res = await this.$http.put<Category>(
      `${this.url}/${category.id}/story-sorting`,
      category,
    );

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async updateOrder(order: number[]): Promise<DataResponse<Category[]>> {
    const res = await this.$http.put<Category[]>(
      `${this.url}/order`,
      order.map((id, index) => ({ id, index })),
    );

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new CategoriesService();
